export default "__VITE_ASSET__DlMP5zAL__"